import Request, {responseValidator, ResultInterface} from "./app/utils/request";
import {MainStateInterface} from "./app/layouts/main.reducer";

export const fetchStore = () => Request.get<ResultInterface<MainStateInterface>>('/initial').then(responseValidator)